import React, { Component } from 'react'
import UserProfileService from '../../../shared/services/UserProfile.service'
import LoadingSpinner from '../../shared/LoadingSpinner.component'
import {
  MDBBtn,
  MDBModalHeader,
  MDBModalBody,
  MDBModal,
  MDBInput,
} from 'mdbreact'
import { toast } from 'react-toastify'
import './EmailSupportModal.component.scss'
import AdminApi from './../../../api/admin-api/admin-api'

class EmailSupportModal extends Component {
  state = {
    loading: false,
    agentInfoModal: false,
    formData: {
      name: '',
      email: '',
      phone: '',
      problemDetails: '',
    },
    formErrors: {
      name: false,
      email: false,
      phone: false,
      problemDetails: false,
    },
  }

  _toggleEmailSupportModal = () => {
    const { loading } = this.state
    if (loading) return

    this.setState({
      agentInfoModal: !this.state.agentInfoModal,
      formData: {
        name: '',
        email: '',
        phone: '',
        problemDetails: '',
      },
      formErrors: {
        name: false,
        email: false,
        phone: false,
        problemDetails: false,
      },
    })
  }

  handleInputChange = (e) => {
    const { name, value } = e.target
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
      formErrors: {
        ...prevState.formErrors,
        [name]: false,
      },
    }))
  }

  validateForm = () => {
    const { formData } = this.state
    const errors = {
      name: !formData.name.trim(),
      email:
        !formData.email.trim() ||
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email),
      phone: !formData.phone.trim(),
      problemDetails: !formData.problemDetails.trim(),
    }

    this.setState({ formErrors: errors })
    return !Object.values(errors).some((error) => error)
  }

  handleSubmit = async (e) => {
    e.preventDefault()

    if (!this.validateForm()) {
      toast.error('Please fill all required fields correctly', {
        position: toast.POSITION.TOP_RIGHT,
      })
      return
    }

    this.setState({ loading: true })

    try {
      const { name, email, phone, problemDetails } = this.state.formData

      const data = {
        name: name,
        email: email,
        phone: phone,
        message: problemDetails,
        req_url: window.location.href,
        ref_url: document.referrer,
      }

      let form_data = new FormData()

      for (let key in data) form_data.append(key, data[key])

      try {
        await AdminApi.createEmailSupportRequest(form_data).then((response) => {
          this.setState({ loading: false })
          if (response.status === 200) {
            this.setState({
              name: '',
              email: '',
              phone: '',
              problemDetails: '',
              formError: false,
            })
            toast.success(
              'Your support ticket has been submitted successfully!',
              {
                position: toast.POSITION.TOP_RIGHT,
              }
            )
          }
        })
      } catch (ex) {
        toast.error('Failed to submit support ticket. Please try again.!', {
          position: toast.POSITION.TOP_RIGHT,
        })
      }

      this._toggleEmailSupportModal()
    } catch (error) {
      toast.error('Failed to submit support ticket. Please try again.!!', {
        position: toast.POSITION.TOP_RIGHT,
      })
    } finally {
      this.setState({ loading: false })
    }
  }

  render() {
    const { formData, formErrors, loading, agentInfoModal } = this.state

    return (
      <>
        <MDBBtn
          className="btn-block support-ticket-btn"
          color="primary"
          onClick={this._toggleEmailSupportModal}
        >
          Submit Ticket
        </MDBBtn>

        <MDBModal
          size="md"
          isOpen={agentInfoModal}
          toggle={this._toggleEmailSupportModal}
        >
          <MDBModalHeader toggle={this._toggleEmailSupportModal}>
            Email Support Ticket
          </MDBModalHeader>
          <MDBModalBody className={loading ? 'is-loading' : ''}>
            {loading ? (
              <div className="loading-wrapper">
                <LoadingSpinner size="md" isActive={true} />
              </div>
            ) : (
              <form onSubmit={this.handleSubmit}>
                <MDBInput
                  label="Your Name *"
                  name="name"
                  value={formData.name}
                  onChange={this.handleInputChange}
                  className={formErrors.name ? 'is-invalid' : ''}
                />
                {formErrors.name && (
                  <div className="invalid-feedback d-block">
                    Please enter your name
                  </div>
                )}

                <MDBInput
                  type="email"
                  label="Email Address *"
                  name="email"
                  value={formData.email}
                  onChange={this.handleInputChange}
                  className={formErrors.email ? 'is-invalid' : ''}
                />
                {formErrors.email && (
                  <div className="invalid-feedback d-block">
                    Please enter a valid email address
                  </div>
                )}

                <MDBInput
                  label="Phone Number *"
                  name="phone"
                  value={formData.phone}
                  onChange={this.handleInputChange}
                  className={formErrors.phone ? 'is-invalid' : ''}
                />
                {formErrors.phone && (
                  <div className="invalid-feedback d-block">
                    Please enter your phone number
                  </div>
                )}

                <MDBInput
                  type="textarea"
                  label="Problem Details *"
                  name="problemDetails"
                  rows="5"
                  value={formData.problemDetails}
                  onChange={this.handleInputChange}
                  className={formErrors.problemDetails ? 'is-invalid' : ''}
                />
                {formErrors.problemDetails && (
                  <div className="invalid-feedback d-block">
                    Please describe your problem
                  </div>
                )}

                <div className="text-center mt-4">
                  <MDBBtn color="primary" type="submit" disabled={loading}>
                    Submit Ticket
                  </MDBBtn>
                  <MDBBtn
                    color="warning"
                    onClick={this._toggleEmailSupportModal}
                    disabled={loading}
                    className="ml-2"
                  >
                    Cancel
                  </MDBBtn>
                </div>
              </form>
            )}
          </MDBModalBody>
        </MDBModal>
      </>
    )
  }
}

export default EmailSupportModal
